const rules = {
  configuration: { required: 'Type is required.' },
  productTitle: { required: 'Product Title is required.' },
  status: { required: 'Status is required.' },
  publish_date: { required: 'Release Date is required.' }
}

export default rules
